import BtnBase from "@components/Buttons/BtnBase";
import { Text } from "@utils/helper";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useDispatch } from "noval";

const setCookiesApproval = (onApproval) => {
  if (typeof window !== "undefined") {
    const updatedSettings = {
      strictly_necessary_cookies: true,
      performance_cookies: true,
      functional_cookies: true,
      social_media_cookies: true,
    };
    localStorage.setItem("cookies_settings", JSON.stringify(updatedSettings));
    if (typeof onApproval === "function") {
      onApproval();
    }
  }
};

const CookiesAlert = ({ onCookiesApproved }) => {
  const { t } = useTranslation("common-locale");
  const { dispatch } = useDispatch();
  return (
    <div className="fixed bottom-0 bg-white py-5 sm:py-10 w-full rounded-t-[16px] z-50 shadow-[-15px_8px_16px_0px_#00000050]">
      <div className="base-container">
        <div className="flex flex-col md:flex-row gap-5 md:gap-[80px] items-start md:items-end">
          <div className="flex flex-col gap-2 sm:gap-5">
            <Text
              weight={500}
              fontType="Expo_bld"
              className="leading-5 !text-[12px] sm:!text-[16px]"
            >
              {t("cookies-approve.title")}
            </Text>
            <Text
              color="#404040"
              weight={400}
              fontType="Expo_bok"
              className="leading-5 !text-[10px] sm:!text-[14px]"
            >
              {t("cookies-approve.desc")}
            </Text>
            <Text
              color="#404040"
              weight={400}
              fontType="Expo_bok"
              className="leading-5 !text-[10px] sm:!text-[14px]"
            >
              {t("cookies-approve.sub_desc")}
            </Text>
            {/* <Link href="/privacy-policy" className="w-fit">
              <Text
                color="#0366FF"
                fontType="Expo_bld"
                weight={700}
                className="leading-5underline !text-[10px] sm:!text-[14px]"
              >
                {t("cookies-approve.read_privacy")}
              </Text>
            </Link> */}
          </div>
          <div className="flex flex-col gap-4 items-end">
            <BtnBase
              onClick={() => setCookiesApproval(onCookiesApproved)}
              sx={{
                textTransform: "capitalize",
                borderRadius: "10px",
                backgroundColor: "#0366FF",
                height: "43px",
                padding: "0",
                px: "24px",
              }}
              className="!w-[140px] sm:!w-[240px]"
            >
              <Text
                fontType="Expo_bok"
                weight="600"
                color="#FFFFFF"
                className="leading-5 !text-[12px] sm:!text-[16px]"
              >
                {t("cookies-approve.accept_all")}
              </Text>
            </BtnBase>
            <BtnBase
              onClick={() => {
                dispatch({ cookiesSettingsOpen: true }, "modals");
              }}
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                borderRadius: "10px",
                height: "43px",
                padding: "0",
                px: "24px",
              }}
              className="!w-[140px] sm:!w-[240px]"
            >
              <Text
                fontType="Expo_bok"
                weight="600"
                className="leading-5 !text-[12px] sm:!text-[16px] !text-[#0366FF] "
              >
                {t("cookies-approve.settings")}
              </Text>
            </BtnBase>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesAlert;
